import { useMemo } from "react";
import { Control, useWatch } from "react-hook-form";
import { computeYearDistributionTotals } from "../helpers/facilityValidation.helpers";
import { FacilityDraftFormValues } from "../types/facilityDrawer.types";

/**
 * Derives per-year "over 100%" errors from the live energy field array, replacing
 * legacy's setError-on-add approach (which cannot be replicated safely against a
 * useFieldArray — see plan risk notes). Keyed by RHF field path so it composes
 * with hasValidationErrors(formState.errors, distributionErrors).
 */
export const useEnergyDistributionErrors = (
  control: Control<FacilityDraftFormValues>
): Record<string, string> => {
  const energy = useWatch({ control, name: "energy" }) ?? [];

  return useMemo(() => {
    const totals = computeYearDistributionTotals(energy);
    const errors: Record<string, string> = {};

    energy.forEach((row, index) => {
      const year = row.Year || "";
      if (!year) return;
      const total = totals.get(year) ?? 0;
      if (total > 100) {
        errors[`energy.${index}.Percentage`] = `Total of percentage in ${year} is over 100`;
      }
    });

    return errors;
  }, [energy]);
};
